import { render } from "./channel-report.vue?vue&type=template&id=56ea345c&lang=pug"
import script from "./channel-report.vue?vue&type=script&lang=js"
export * from "./channel-report.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__